var _this = this;
import * as tslib_1 from "tslib";
import loadTableViewFromTableQuery from '../actions/loadTableViewFromTableQuery';
import { onMailSearchComplete } from 'owa-mail-actions/lib/mailSearchActions';
import { loadTableViewFromSearchTableQuery, } from 'owa-mail-search';
import { orchestrator } from 'satcheljs';
export default orchestrator(loadTableViewFromSearchTableQuery, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var searchTableQuery, searchEndToEndPerformanceDatapoint, actionSource;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchTableQuery = actionMessage.searchTableQuery, searchEndToEndPerformanceDatapoint = actionMessage.searchEndToEndPerformanceDatapoint, actionSource = actionMessage.actionSource;
                // Load table view from search table query (makes search requests in here).
                return [4 /*yield*/, loadTableViewFromTableQuery(searchTableQuery, searchEndToEndPerformanceDatapoint, actionSource)];
            case 1:
                // Load table view from search table query (makes search requests in here).
                _a.sent();
                // Marks the end of the datapoint (maybe can do with promise above).
                searchEndToEndPerformanceDatapoint.addCheckmark('promise');
                // End SearchEndToEnd datapoint since search results are now loaded.
                searchEndToEndPerformanceDatapoint.end();
                // Once table view has loaded, dispatch action to notify search completed.
                onMailSearchComplete();
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=loadTableViewFromSearchTableQueryOrchestrator.js.map